
'use strict';

define('component!AcademyProgressBar',['require','react','create-react-class','underscore','lib/prototype/String.prototype'],function (require) {
  'use strict';

  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var _ = require('underscore');
  require('lib/prototype/String.prototype');

  var AcademyProgressBar = ReactCreateClass({
    displayName: 'AcademyProgressBar',

    getInitialState: function getInitialState() {
      return {
        progress: this.getProgressFromAssignments(this.props.course.assignments),
        course: this.props.course
      };
    },

    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        progress: this.getProgressFromAssignments(nextProps.course.assignments)
      });
    },

    getProgressFromAssignments: function getProgressFromAssignments(assignments) {
      var completedStates = _.pluck(assignments, 'completed');
      return this.calculatePercentDone(completedStates);
    },

    calculatePercentDone: function calculatePercentDone(booleanArray) {
      var total = booleanArray.length;
      var done = _.reduce(booleanArray, function (memo, bool) {
        return bool ? memo + 1 : memo;
      }, 0);
      return Math.round(done / total * 100);
    },

    render: function render() {
      var inlineStyle = {
        width: '{0}%'.format(this.state.progress)
      };

      return React.createElement(
        'div',
        { className: 'academy-progress-bar' },
        React.createElement(
          'div',
          { className: 'meter' },
          React.createElement('div', { className: 'progress', ref: 'progress', style: inlineStyle })
        )
      );
    }
  });

  return AcademyProgressBar;
});
